// extracted by mini-css-extract-plugin
export default {"quizAnimationContainer":"QuizAnimation_quizAnimationContainer__os-qa","quizAnimation":"QuizAnimation_quizAnimation__U+28I"};